import { render, staticRenderFns } from "./ScheduleLayout.vue?vue&type=template&id=1624816c&scoped=true"
import script from "./ScheduleLayout.vue?vue&type=script&lang=js"
export * from "./ScheduleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1624816c",
  null
  
)

export default component.exports